import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";

import {
    faPaperclip,
    faPaperPlane,
    faTimes,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import SpinnerComponent from "../../../../Components/Loding/Spinner";

import { ListarContatosController } from "../../../../Controllers/Geral/Contatos/ContatosController";
import {
    ListarDocumentoTemplateController,
    SetVariaveisDocumentoController,
} from "../../../../Controllers/Geral/Documentos/DocumentosController";
import { EnviarEmailAnexoController } from "../../../../Controllers/Geral/Email/EmailController";

import { ListarEmailContaPorUsuarioController } from "../../../../Controllers/Geral/Grupos/GruposEmailsController";

import "./styles.css";
import useAsyncEffect from "../../../../hooks/useAsyncEffect";
import { AlertWarning } from "../../../../Tools/SweetAlerts";
import { useAtendimentoPage } from "../../../../Context/AtendimentoPage";
import CreatableSelect from "react-select/creatable";
import { IEmailConta } from "../../../../Interfaces/Geral/GestaoDeCadastro/Emailconta/EmailContaInterface";
import { FroalaEditor } from "../../../../Components/CardsPages/Forms/Editor/FroalaEditor";
import { useUserInfor } from "../../../../Context/User";
import { useHistoricoContext } from "../../../../Context/Historico";

interface htmlQuill {
    editorHtml: string;
}

interface IEnviarEmailProps {
    ID_CONTA: number;
    ID_CASO: number;
    ID_CONTATO: number;
    setShow: (show: boolean) => void;
    anexosDefault?: Array<File>;
    assuntoDefault?: string;
}
//

interface PropsFormData extends htmlQuill {
    email_remetente: number;
    assunto: string;
    file: Array<File>;
    cc: string;
    cco: string;
}

export function EnviarEmail(props: IEnviarEmailProps) {
    const { updateDoc, idModulo } = useAtendimentoPage();
    const { register, handleSubmit, formState, setValue } = useForm();
    const { ReloadHistorico, cadastrarHistoricoRef } = useHistoricoContext();
    const [LstDocs, setLstDocs] = useState(props.anexosDefault);
    const [Loading, setLoading] = useState(false);
    const [ButtonBlock, setButtonBlock] = useState(false);
    const [convertedText, setConvertedText] = useState<htmlQuill>({
        editorHtml: "",
    } as htmlQuill);
    const [emailDestinatario, setEmailDestinatario] = useState<
        Array<string> | undefined
    >([]);
    const [copiaCarbono, setCopiaCarbono] = useState<string[]>([""]);
    const [copiaCarbonoOculta, setCopiaCarbonoOculta] = useState<string[]>([
        "",
    ]);
    const [emailRemetente, setEmailRemetente] = useState(0);
    // eslint-disable-next-line
    const [uploading, setUploading] = useState(false);
    const [uploadedImages, setUploadedImages] = useState<string[]>([]);
    const userId = useUserInfor().UserInfor.ID_USUARIO;

    const { value: lstContatos, ...ListarContatos } = useAsyncEffect(
        () => ListarContatosController(props.ID_CONTA, props.ID_CASO),
        [props.ID_CONTA]
    );

    const { value: LstDocumentoTemplate } = useAsyncEffect(
        () =>
            ListarDocumentoTemplateController({
                idTipoCaso: idModulo,
                FL_NAO_CARREGA_TEMPLATE: true,
            }),
        [idModulo]
    );
    const { value: LstEmailContaPorUsuario } = useAsyncEffect(
        ListarEmailContaPorUsuarioController
    );
    const onSubmitHandleImage = () => {
        if (userId && convertedText && convertedText.editorHtml) {
            // Mapeia o html e substitui o src pelo link que é armazenado no state uploadedImages de forma dinamica
            let modifiedHistoricoHTML = convertedText.editorHtml;
            const imagesToReplace =
                modifiedHistoricoHTML.match(
                    /<img[^>]*src="blob[^"]*"[^>]*>/g
                ) || [];

            imagesToReplace.forEach((imageTag) => {
                const uploadedImageUrl = uploadedImages.shift() || "";
                modifiedHistoricoHTML = modifiedHistoricoHTML.replace(
                    /<img[^>]*src="blob[^"]*"[^>]*>/,
                    imageTag.replace(
                        /src="blob[^"]*"/,
                        `src="${uploadedImageUrl}"`
                    )
                );
            });
            convertedText.editorHtml = modifiedHistoricoHTML;
        }
    };

    useEffect(() => {
        if (LstEmailContaPorUsuario && LstEmailContaPorUsuario.length > 0)
            setEmailRemetente(LstEmailContaPorUsuario![0].ID_EMAIL_CONTA);
    }, [LstEmailContaPorUsuario]);

    useEffect(() => {
        if (LstEmailContaPorUsuario && emailRemetente && lstContatos) {
            let emailContaUsuarioFiltrado: IEmailConta[] =
                LstEmailContaPorUsuario.filter(
                    (x) => x.ID_EMAIL_CONTA === emailRemetente
                );

            if (
                emailContaUsuarioFiltrado &&
                emailContaUsuarioFiltrado.length > 0 &&
                emailContaUsuarioFiltrado[0].DS_COPIA &&
                emailContaUsuarioFiltrado[0].DS_COPIA_OCULTA
            ) {
                setCopiaCarbono(
                    typeof emailContaUsuarioFiltrado[0].DS_COPIA === "string"
                        ? emailContaUsuarioFiltrado[0].DS_COPIA.split(",")
                        : emailContaUsuarioFiltrado[0].DS_COPIA
                );
                setCopiaCarbonoOculta(
                    typeof emailContaUsuarioFiltrado[0].DS_COPIA_OCULTA ===
                        "string"
                        ? emailContaUsuarioFiltrado[0].DS_COPIA_OCULTA.split(
                              ","
                          )
                        : emailContaUsuarioFiltrado[0].DS_COPIA_OCULTA
                );
            }
        }
    }, [LstEmailContaPorUsuario, lstContatos, emailRemetente]);

    const options = lstContatos?.map((contato) => ({
        label: `${contato.DS_EMAIL ? contato.DS_NOME : ""} ${
            contato.DS_EMAIL ? `<${contato.DS_EMAIL}>` : ""
        }`,
        value: contato.DS_EMAIL ?? "",
    }));

    const customStyles = {
        control: (base: any) => ({
            ...base,
            boxShadow: "none",
        }),
    };

    function defaultValue() {
        return {
            value:
                lstContatos?.filter((c) => c.FL_PROPONENTE === true)[0]
                    ?.DS_EMAIL ?? "",
            label: `${
                lstContatos?.filter((c) => c.FL_PROPONENTE === true)[0]
                    ?.DS_NOME ?? ""
            } <${
                lstContatos?.filter((c) => c.FL_PROPONENTE === true)[0]
                    ?.DS_EMAIL ?? ""
            }>`,
        };
    }

    function handleInserirCasoFormSubmit(formData: PropsFormData) {
        setLoading(true);
        onSubmitHandleImage();
        EnviarEmailAnexoController({
            File: LstDocs,
            DS_ASSUNTO: formData.assunto,
            DS_MENSAGEM: convertedText.editorHtml,
            ID_CASO: props.ID_CASO,
            ID_EMAIL_CONTA: formData.email_remetente,
            DS_DESTINATARIO:
                (emailDestinatario?.length || [].length) > 0
                    ? emailDestinatario
                    : lstContatos?.filter((c) => c.FL_PROPONENTE === true)[0]
                          .DS_EMAIL ?? "",
            DS_COPIA_CARBONO: copiaCarbono
                ? formData.cc.concat(";" + copiaCarbono.join()) === ";"
                    ? ""
                    : formData.cc.concat(";" + copiaCarbono.join())
                : "",
            DS_COPIA_CARBONO_OCULTA:
                copiaCarbonoOculta &&
                copiaCarbonoOculta.length > 1 &&
                copiaCarbonoOculta[0] !== ""
                    ? copiaCarbonoOculta[0]
                    : formData.cco && formData.cco !== null
                    ? formData.cco.split(";")[0]
                    : "",
        })
            .then((res) => {
                if (LstDocs && LstDocs.length > 0) updateDoc();
                props.setShow(false);
                cadastrarHistoricoRef.current = undefined;
                ReloadHistorico();
            })
            .catch(() => {
                setLoading(false);
            });
    }

    function handleChange(html: string) {
        setConvertedText({ editorHtml: html });
    }

    return ListarContatos.loading ? (
        <SpinnerComponent />
    ) : (
        <div className="col-12">
            <form
                onSubmit={handleSubmit(handleInserirCasoFormSubmit)}
                className="w-100 align-itens-center mt-5"
            >
                <div className="row d-flex flex-wrap">
                    <div className="col-12 col-lg-6 mt-2">
                        <label>Email Remetente:</label>
                        <select
                            name="email_remetente"
                            className={`form-control placeholder-dark-50  ${
                                formState.errors.email_remetente && "is-invalid"
                            }`}
                            ref={register({
                                required: "Insira o email",
                                valueAsNumber: true,
                            })}
                            onChange={(e) => {
                                let emptyStringArray: string[] = [];
                                setCopiaCarbono(emptyStringArray);
                                setCopiaCarbonoOculta(emptyStringArray);
                                setEmailRemetente(
                                    Number.parseInt(e.target.value)
                                );
                            }}
                        >
                            {LstEmailContaPorUsuario &&
                                LstEmailContaPorUsuario.map((email) => {
                                    return (
                                        <option
                                            key={email.ID_EMAIL_CONTA}
                                            value={email.ID_EMAIL_CONTA}
                                        >
                                            {email.DS_REMETENTE}
                                        </option>
                                    );
                                })}
                        </select>
                    </div>

                    <div className="col-12 col-lg-6 mt-2">
                        <label>Email Destinatário:</label>
                        <CreatableSelect
                            isMulti
                            isClearable
                            isSearchable
                            onChange={(e) => {
                                setEmailDestinatario(
                                    e.map((value) => value?.value)
                                );
                            }}
                            formatCreateLabel={(value) =>
                                `Clique para selecionar: ${value}`
                            }
                            styles={customStyles}
                            placeholder={"Digite o email"}
                            options={options}
                            defaultValue={
                                lstContatos?.filter(
                                    (c) => c.FL_PROPONENTE === true
                                )[0]?.DS_EMAIL !== ""
                                    ? defaultValue()
                                    : undefined
                            }
                            className="Select-menu-outer"
                        />
                    </div>
                </div>
                <div className="row mb-3 d-flex flex-wrap">
                    <div className="col-12 col-lg-4 mt-2">
                        <label>Cópia Carbono:</label>
                        <input
                            type="text"
                            name="cc"
                            placeholder={"Digite o email para cópia"}
                            className={`form-control px-0 p-2 placeholder-muted-75`}
                            ref={register()}
                        />
                    </div>

                    <div className="col-12 col-lg-4 mt-2">
                        <label>Cópia Carbono Oculta:</label>
                        <input
                            type="text"
                            name="cco"
                            placeholder={"Digite o email para cópia oculta"}
                            className={`form-control px-0 p-2 placeholder-muted-75`}
                            ref={register()}
                        />
                    </div>

                    <div className="col-12 col-lg-4 mt-2">
                        <label>Template de Email:</label>
                        <select
                            className={`form-control placeholder-dark-50  ${
                                formState.errors.ID_MODELO_EMAIL && "is-invalid"
                            }`}
                            onChange={(e) => {
                                const idTemplateEmail = Number.parseInt(
                                    e.target.value
                                );
                                if (e && idTemplateEmail) {
                                    const docTemplate =
                                        LstDocumentoTemplate?.find(
                                            (dt) =>
                                                dt.ID_DOCUMENTO_TEMPLATE ===
                                                idTemplateEmail
                                        );
                                    if (docTemplate && docTemplate.DS_ASSUNTO)
                                        setValue(
                                            "assunto",
                                            docTemplate.DS_ASSUNTO
                                        );
                                    setButtonBlock(true);
                                    setConvertedText({
                                        editorHtml: "Carregando....",
                                    });
                                    SetVariaveisDocumentoController(
                                        idTemplateEmail,
                                        props.ID_CASO,
                                        2
                                    )
                                        .then((res) => {
                                            setConvertedText({
                                                editorHtml: res,
                                            });
                                            setButtonBlock(false);
                                        })
                                        .catch(() => {
                                            setConvertedText({
                                                editorHtml:
                                                    "Erro ao carregar template.",
                                            });
                                        });
                                }
                            }}
                        >
                            <option>Modelo de email</option>
                            {LstDocumentoTemplate &&
                                LstDocumentoTemplate.map((doc) => {
                                    return (
                                        <option
                                            key={doc.ID_DOCUMENTO_TEMPLATE}
                                            value={doc.ID_DOCUMENTO_TEMPLATE}
                                        >
                                            {doc.DS_DOCUMENTO}
                                        </option>
                                    );
                                })}
                        </select>
                    </div>
                </div>
                <div className="row mb-3 d-flex flex-wrap">
                    <div className="col-12 col-lg-11">
                        <input
                            type="text"
                            name="assunto"
                            placeholder="Assunto:"
                            autoComplete="off"
                            className={`form-control px-0 p-2 placeholder-muted-75 ${
                                formState.errors.assunto && "is-invalid"
                            }`}
                            defaultValue={props.assuntoDefault}
                            ref={register({
                                required: "Insira o Assunto do E-mail",
                            })}
                        />
                    </div>
                    <div className="col-12 col-lg-1 btn btn-clean btn-icon btn-md ">
                        <label
                            htmlFor="file_input_enviar_email"
                            className="m-0"
                        >
                            Anexo:{" "}
                            <FontAwesomeIcon
                                icon={faPaperclip}
                                className="ml-1 mr-1"
                                size="lg"
                            />
                        </label>
                        <input
                            type="file"
                            multiple
                            name="file"
                            id="file_input_enviar_email"
                            className="d-none"
                            onChange={async (e) => {
                                const docs: Array<File> = Array.from(
                                    LstDocs || []
                                );

                                for (
                                    let index = 0;
                                    index < (e.target.files?.length || 0);
                                    index++
                                ) {
                                    const element = e.target.files?.item(index);
                                    if (element && element.size > 10_000_000)
                                        // arquivo não pode ser maior que 10MB
                                        await AlertWarning(
                                            "Não foi possível anexar o arquivo!",
                                            `O arquivo ${element.name} não pode ser enviado por e-mail pois ele é maior que 10MB`
                                        );
                                    else if (element) docs.push(element);
                                }
                                setLstDocs(docs);
                            }}
                            ref={register()}
                        />
                    </div>

                    {LstDocs && LstDocs.length > 0 ? (
                        LstDocs.map((arquivo: File, index) => {
                            return (
                                <div
                                    key={index}
                                    className="d-flex flex-wrap justify-content-between ml-1"
                                >
                                    <div
                                        className="btn btn-clean col-12 col-lg-12 d-flex justify-content-between mt-2 ml-2"
                                        onClick={() => {
                                            setLstDocs(
                                                LstDocs.filter(
                                                    (doc) =>
                                                        doc.name !==
                                                        arquivo.name
                                                )
                                            );
                                        }}
                                    >
                                        {arquivo.name.length > 20
                                            ? arquivo.name.substr(0, 20) + "..."
                                            : arquivo.name}
                                        <FontAwesomeIcon
                                            icon={faTimes}
                                            className="text-danger ml-2"
                                        />
                                    </div>
                                </div>
                            );
                        })
                    ) : (
                        <div></div>
                    )}
                </div>
                <div className="row mb-3 d-flex flex-wrap">
                    <div className=" w-100 h-100 p-4">
                        {/* <Editor
                            value={convertedText.editorHtml || ""}
                            onChange={handleChange}
                            placeholder="Mensagem:*"
                        /> */}
                        <div className="froala-editor">
                            <FroalaEditor
                                onChange={(e) => {
                                    handleChange(e);
                                }}
                                value={convertedText.editorHtml || ""}
                                onImageUploadStart={() => setUploading(true)}
                                onImageUploadEnd={() => setUploading(false)}
                                setUploadedImages={setUploadedImages}
                            />
                        </div>
                        {Loading || uploading ? (
                            <button
                                type="button"
                                className="btn btn-outline-primary font-weight-bold d-flex col-12 justify-content-center"
                            >
                                <div className="row px-4">
                                    <div className="loading-component">
                                        <div
                                            className="spinner-border spinner-border-sm text-light"
                                            role="status"
                                        >
                                            <span className="sr-only">
                                                Carregando...
                                            </span>
                                        </div>
                                    </div>
                                    <div className="ml-2">
                                        {uploading
                                            ? "Carregando imagem"
                                            : "Enviar por email"}
                                    </div>
                                </div>
                            </button>
                        ) : (
                            <button
                                disabled={ButtonBlock}
                                className="btn btn-outline-primary font-weight-bold d-flex col-12 justify-content-center"
                            >
                                <FontAwesomeIcon
                                    icon={faPaperPlane}
                                    size="lg"
                                    className="mr-1"
                                />{" "}
                                Enviar por email
                            </button>
                        )}
                    </div>
                </div>
            </form>
        </div>
    );
}
